import React, { useState } from "react";

function PopUp({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    fullName: "",
    mobileNumber: "",
    emailAddress: "",
    location: "",
    additionalNotes: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you! We will contact you shortly.");
    setFormData({
      fullName: "",
      mobileNumber: "",
      emailAddress: "",
      location: "",
      additionalNotes: "",
    });
  };

  return (
    <div className={`popup ${isOpen ? "popup-open" : ""}`} style={{ display: isOpen ? "flex" : "none" }}>
      <div className="popup-content">
        <span className="close-btn" onClick={onClose}>&times;</span>
        <h2>Enter Your Contact Information</h2>
        <h6>Please provide your contact details below so we can get in touch with you.</h6>
        <form id="bookingForm" onSubmit={handleSubmit}>
          <input
            type="text"
            name="fullName"
            placeholder="Full Name"
            required
            value={formData.fullName}
            onChange={handleChange}
          />
          <input
            type="number"
            name="mobileNumber"
            placeholder="Mobile Number"
            required
            value={formData.mobileNumber}
            onChange={handleChange}
          />
          <input
            type="email"
            name="emailAddress"
            placeholder="Email Address (Optional)"
            value={formData.emailAddress}
            onChange={handleChange}
          />
          <input
            type="text"
            name="location"
            placeholder="Location"
            required
            value={formData.location}
            onChange={handleChange}
          />
          <textarea
            name="additionalNotes"
            placeholder="Additional Notes (Optional)"
            value={formData.additionalNotes}
            onChange={handleChange}
          ></textarea>
          <label>
            *By clicking the "Book Now" button, you agree to our
            <a href="#" target="_blank" rel="noopener noreferrer">Terms & Conditions</a> and
            <a href="#" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
          </label>
          <button type="submit" className="btn-primary">Submit</button>
        </form>
      </div>
    </div>
  );
}

export default PopUp;
